"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r={position:"absolute",transform:"translate(-50%, -50%)"},e={position:"relative",marginTop:"-46px"};exports.markerRoot=e;exports.markerWrapper=r;
